/**
 * Legacy-Redirect: /contacts → /people — People-Merge (v2-Relaunch)
 *
 * SPEC.md Global decisions (2026-09-01): "People = Contact + Host merged
 * ... Routes /contacts/* and /hosts/* 301 → /people/*." Die Kontakt-Liste
 * lebt jetzt clientseitig gemergt unter /people (siehe
 * features/contacts/ContactsPage.tsx). /contacts/:id bleibt unveraendert
 * bestehen (Contact-Detailseite, ausserhalb dieses Auftrags).
 *
 * Vorherige Fassung (2026-09-01, Validierung Runde 4) rendierte hier direkt
 * die ContactsPage — das war korrekt, bevor es eine eigene /people-Route
 * gab. Jetzt greift der Redirect wie bei den anderen Legacy-Pfaden (siehe
 * layouts/nav.ts, LEGACY_PATH_REDIRECTS).
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/contacts/')({
  beforeLoad: () => {
    throw redirect({ to: '/people', replace: true })
  },
  component: () => null,
})
